import { getImageFromS3 } from '../imageService';

export const trueFalseFactsChallengeList = [
  {
    id: '1',
    title: 'Традиційна страва в Китаї готується зі слини птахів.',
    image: getImageFromS3('/images/true-false-challenge/bnd/1.png'),
    isCorrect: true,
    imageText:
      'Традиційна делікатесна страва в Китаї — це суп із гнізд саланганів. Ці птахи будують їх із затверділої слини.'
  },
  {
    id: '2',
    title: 'Банан — це фрукт.',
    image: getImageFromS3('/images/true-false-challenge/bnd/2.png'),
    isCorrect: false,
    imageText: 'З ботанічної точки зору банан — це ягода.'
  },
  {
    id: '3',
    title: 'Гриби ближчі до тварин, ніж до рослин.',
    image: getImageFromS3('/images/true-false-challenge/bnd/3.png'),
    isCorrect: true,
    imageText:
      'За генетичною структурою та способом живлення гриби мають більше спільного з людьми, ніж із квітами чи деревами.'
  },
  {
    id: '4',
    title: 'Морква з самого початку була помаранчевою.',
    image: getImageFromS3('/images/true-false-challenge/bnd/4.png'),
    isCorrect: false,
    imageText:
      'Первісні сорти, що культивувалися тисячі років тому, були фіолетовими, білими або жовтими.'
  },
  {
    id: '5',
    title: 'Яблука на 25% складаються з повітря.',
    image: getImageFromS3('/images/true-false-challenge/bnd/5.png'),
    isCorrect: true,
    imageText:
      'Саме тому вони не тонуть у воді. Це також пояснює їхній характерний хрускіт, коли ви їх кусаєте.'
  }
];

export const trueFalseFactsResultList = [
  {
    resultId: '1',
    title: 'Вітаємо, твоя інтуіція працює чудово!',
    text: 'Ти добре знаєш, де факт, а де вигадка, і не так легко ведешся на міфи.',
    image: getImageFromS3('images/true-false-challenge/bnd/result1.png')
  },
  {
    resultId: '2',
    title: 'Непогано!',
    text: 'Деякі факти ще можуть тебе здивувати, але тепер ти точно знаєш трохи більше, ніж до тесту.',
    image: getImageFromS3('images/true-false-challenge/bnd/result2.png')
  }
];
